export default "__VITE_ASSET__DzFGw4Vl__"